import { render } from "./ContentTabMenu.vue?vue&type=template&id=0bb46e24&scoped=true&ts=true"
import script from "./ContentTabMenu.vue?vue&type=script&lang=ts"
export * from "./ContentTabMenu.vue?vue&type=script&lang=ts"

import "./ContentTabMenu.vue?vue&type=style&index=0&id=0bb46e24&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bb46e24"]])

export default __exports__